var map = {
	"./lightbox/close": 6,
	"./lightbox/close.png": 6,
	"./lightbox/close@2x": 7,
	"./lightbox/close@2x.png": 7,
	"./lightbox/loading": 8,
	"./lightbox/loading.gif": 8,
	"./lightbox/loading@2x": 9,
	"./lightbox/loading@2x.gif": 9,
	"./lightbox/next": 10,
	"./lightbox/next.png": 10,
	"./lightbox/next@2x": 11,
	"./lightbox/next@2x.png": 11,
	"./lightbox/prev": 12,
	"./lightbox/prev.png": 12,
	"./lightbox/prev@2x": 13,
	"./lightbox/prev@2x.png": 13,
	"./logo_t8": 14,
	"./logo_t8.svg": 14,
	"./logo_t8_t": 15,
	"./logo_t8_t.svg": 15,
	"./overlay_lightbox": 16,
	"./overlay_lightbox.png": 16,
	"./roses/rose_darkred": 17,
	"./roses/rose_darkred.jpg": 17,
	"./roses/rose_red": 18,
	"./roses/rose_red.png": 18,
	"./valentin_rosen_dunkelrot": 19,
	"./valentin_rosen_dunkelrot.jpeg": 19,
	"./valentin_rosen_rot": 20,
	"./valentin_rosen_rot.png": 20,
	"./wines/Langhe-Nebbiolo": 21,
	"./wines/Langhe-Nebbiolo.jpg": 21,
	"./wines/Montepulciano-dAbruzzo": 22,
	"./wines/Montepulciano-dAbruzzo.jpg": 22,
	"./wines/Riesling-1-PS": 23,
	"./wines/Riesling-1-PS.jpg": 23,
	"./wines/Schloss-VAUX-rose-brut": 24,
	"./wines/Schloss-VAUX-rose-brut.jpg": 24,
	"./wines/Weißburgunder_Lehm": 25,
	"./wines/Weißburgunder_Lehm.jpg": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;